function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#0074C2",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.4 14.156c-.411.28-.902.42-1.4.397-.498.022-.989-.117-1.4-.397L0 8.5v10.023C0 20.167 1.343 21.5 3 21.5h18c1.657 0 3-1.333 3-2.977V8.5l-10.6 5.656z",
  transform: "translate(-1225 -1095) translate(1225 1047) translate(0 48) translate(0 .5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 .5H3C1.343.5 0 1.843 0 3.499v1c-.002.366.188.707.5.9l11 5.997c.154.081.327.116.5.1.173.016.346-.019.5-.1l11-5.998c.312-.192.502-.533.5-.9V3.5C24 1.843 22.657.5 21 .5z",
  transform: "translate(-1225 -1095) translate(1225 1047) translate(0 48) translate(0 .5)"
}))))));

var SvgMailBlue = function SvgMailBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-blue.46808289.svg";
export { ForwardRef as ReactComponent };